import apiClient from '@/clients/apiClient';
import { saveAs } from 'file-saver';

export const getCompanyList = (
  page = 1,
  pageSize = 10,
  search = '',
  isRegistered = '',
  isPlatformMerchant = '',
  status = '',
  startAt = '',
  endAt = '',
  referralSource = '',
  registeredPlatform = '',
  onboardingSteps = [],
  sortBy = '',
  orderBy = ''
) => {
  const params = new URLSearchParams({
    Page: page,
    PageSize: pageSize,
    Search: search,
    IsRegistered: isRegistered,
    IsPlatformMerchant: isPlatformMerchant,
    Status: status,
    CreatedStartAt: startAt,
    CreatedEndAt: endAt,
    ownerReferralSource: referralSource,
    ownerRegisteredPlatform: registeredPlatform,
    'Sort.Sort_By': sortBy,
    'Sort.Order_By': orderBy,
  });

  if (onboardingSteps && onboardingSteps.length > 0) {
    onboardingSteps.forEach((step) => {
      params.append('OnboardingSteps', step);
    });
  }

  return apiClient.get(`businesses?${params.toString()}`);
};

export const getNewCompanies = (page = 1, pageSize = 10, search = '') =>
  apiClient.get(`businesses/new?Page=${page}&PageSize=${pageSize}&Search=${search}`);

export const getChangedCompanies = (page = 1, pageSize = 10, search = '') =>
  apiClient.get(`businesses/changed?Page=${page}&PageSize=${pageSize}&Search=${search}`);

export const getCompanyProfile = (id) => apiClient.get(`businesses/${id}`);

export const getKybChecklist = (id) => apiClient.get(`businesses/${id}/checklist`);

export const getCompanyDocuments = (id) => apiClient.get(`businesses/${id}/documents`);

export const uploadCompanyDocument = (payload) =>
  apiClient.post(`businesses/${payload.businessId}/documents`, payload.data);

export const getCompanyLoanRequests = (id) => apiClient.get(`businesses/${id}/loan-requests`);

export const getCompaniesCount = () => apiClient.get('businesses/entities/count');

export const createCompany = (data) => apiClient.post('businesses', data);

export const verifyOrReverifyCompany = (businessProfileId, verificationType) =>
  apiClient.post(`businesses/${businessProfileId}/${verificationType}`, {});

export const verifyKybItem = (data, businessId) =>
  apiClient.put(`businesses/${businessId}/verifykybitem`, data);

export const getCompanyWallets = (businessId) =>
  apiClient.get(`businesses/${businessId}/wallets`);

export const editCompany = (payload) =>
  apiClient.put(`businesses/${payload.businessId}`, payload.data);

export const updateCompanyLogo = (payload) =>
  apiClient.post(`businesses/${payload.businessId}/logo`, payload.data);

export const getUnpaginatedBusinessList = () => apiClient.get(`businesses/lite`);

export const runCreditCheck = (businessId) =>
  apiClient.post(`businesses/${businessId}/run-credit-check`, {});

export const getCreditProfile = (businessId) =>
  apiClient.get(`businesses/${businessId}/credit-profile-details`);

export const getCompanySimilarities = (businessId) =>
  apiClient.get(`businesses/${businessId}/similarities`);

export const reportCompanySimilarity = (businessId, recommendation, comments = '') =>
  apiClient.post(`businesses/${businessId}/report-similarity`, {
    recommendation,
    ...(comments ? { comments } : {}),
  });

export const exportCompaniesList = (
  type,
  page = 1,
  pageSize = 10,
  search = '',
  isRegistered = '',
  isPlatformMerchant = '',
  status = '',
  startAt = '',
  endAt = '',
  referralSource = '',
  registeredPlatform = '',
  onboardingSteps = [],
  sortBy = '',
  orderBy = ''
) => {
  const params = new URLSearchParams({
    Page: page,
    PageSize: pageSize,
    Search: search,
    IsRegistered: isRegistered,
    IsPlatformMerchant: isPlatformMerchant,
    Status: status,
    CreatedStartAt: startAt,
    CreatedEndAt: endAt,
    ownerReferralSource: referralSource,
    ownerRegisteredPlatform: registeredPlatform,
    'Sort.Sort_By': sortBy,
    'Sort.Order_By': orderBy,
  });

  if (onboardingSteps && onboardingSteps.length > 0) {
    onboardingSteps.forEach((step) => {
      params.append('OnboardingSteps', step);
    });
  }

  return apiClient
    .get(`businesses/export/${type}?${params.toString()}`, { responseType: 'blob' })
    .then((response) => {
      saveAs(response.data, `businesses.${type}`);
    });
};
